import { AgentChat } from "@/components/chat/AgentChat";

export default function Orientation() {
  return <AgentChat agent="orientation" />;
}
